import React from 'react';

const NoMatch = () => {
    return (
        <div className="no-match">
            <div className="container">
                <div className="no-match-content text-center my-auto">
                    <h3>Page Not Found</h3>
                    <h1>404</h1>
                    <p>Lorem ipsum dolor sit amet consectetur.</p>
                </div>
            </div>
        </div>
    );
};

export default NoMatch;